export default __webpack_public_path__ + "locales/sk/Notifications.json?hash=eab613e6094700179362b0afc130e8d7";